import React from 'react';
import { formatValue } from '../../utils';

export default class Result extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            updated: false
        }
    }

    static getDerivedStateFromProps(props, state) {
        return {
            updated: props.updated
        };
    }

    render() {
        const { mtd, net } = this.props;
        const { updated } = this.state;

        return  (
            <div className='row'>
                <div className='col-sm-12 col-md-6 col-xl-4'>
                    <div className={'pcb-result' + (updated ? ' updated' : '')}>
                        <div className='label'>Monthly PCB Deduction</div>
                        <div className='value'>RM {formatValue(mtd)}</div>
                    </div>
                </div>

                <div className='col-sm-12 col-md-6 col-xl-4'>
                    <div className={'pcb-result' + (updated ? ' updated' : '')}>
                        <div className='label'>Net Income</div>
                        <div className='value'>RM {formatValue(net)}</div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Calculator/Result.js